import React, { useEffect, useState } from "react";
import {
  getMapDiagnosticState,
  MAP_DIAGNOSTICS_ENABLED,
  subscribeMapDiagnostics,
} from "../services/mapDiagnostics";

const yn = (value) => value ? "YES" : "NO";

export default function MapDiagnosticPanel() {
  const [state, setState] = useState(getMapDiagnosticState);
  useEffect(() => subscribeMapDiagnostics(setState), []);
  if (!MAP_DIAGNOSTICS_ENABLED) return null;

  const location = state.latitude == null
    ? "WAITING"
    : `${state.locationValid ? "PASS" : "FAIL"} (${state.latitude}, ${state.longitude})`;
  const container = state.containerWidth == null
    ? "WAITING"
    : `${state.containerWidth > 0 && state.containerHeight > 0 ? "PASS" : "FAIL"} (${state.containerWidth}x${state.containerHeight})`;
  const lastError = state.lastError?.message || state.failureType || "NONE";

  return (
    <aside className="zuno-map-diagnostics" aria-label="Diagnóstico temporário do mapa">
      <b>MAP DIAGNOSTICS</b>
      <span>ORIGIN = {state.origin}</span>
      <span>REFERRER = {state.referrer}</span>
      <span>MAP_SCRIPT = {state.mapScript}</span>
      <span>GOOGLE_MAPS = {yn(state.googleMapsMap)}</span>
      <span>AUTH_FAILURE = {yn(state.authFailure)}</span>
      <span>MAP_CREATED = {yn(state.mapCreated)}</span>
      <span>CONTAINER = {container}</span>
      <span>LOCATION = {location}</span>
      <span>LAST_ERROR = {lastError}</span>
    </aside>
  );
}
